<template>
  <v-card>
    <!-- Print Button -->
    <div class="d-flex justify-end mb-4 mr-4">
      <v-btn color="primary" @click="printTable">
        <v-icon left>mdi-printer</v-icon>
        Print
      </v-btn>
    </div>
    <v-row>
      <v-col cols="12">
        <v-card class="mb-5 pa-4">
          <v-card-title>
            <span class="headline">Good Received Note Number :  #{{ grnDetails.grn_number }}</span>
          </v-card-title><br>
          <v-card-subtitle>
            <div>
              <strong>Supplier Name:</strong> {{ grnDetails.supplier_name }}<br>
              <strong>PO Number:</strong> {{ grnDetails.po_number }}<br>
              <strong>PO Date:</strong> {{ grnDetails.po_date }}<br>
              <strong>Remarks:</strong> {{ grnDetails.remarks }}<br>
             
              
            </div>
          </v-card-subtitle>
        </v-card>
      </v-col>
    </v-row>

    <!-- Items Table -->
    <v-data-table
      v-if="items && items.length > 0"
      :headers="itemHeaders"
      :items="items"
      dense
      item-key="id"
      hide-default-footer
    >
      <template v-slot:item="{ item, index }">
        <tr
          :class="[index % 2 === 0 ? 'dark-row' : 'light-row', 'custom-row']"
          
        >
          <td>{{ item.product_code }}</td>
          <td>{{ item.batch ? item.batch.batch_code : 'N/A' }}</td>
          <td>{{ item.description }}</td>
          <td>{{ item.quantity_received }}</td>
          <td>{{ item.unit_price }}</td>
          <td>{{ item.total_price }}</td>

         
        </tr>
      </template>
    </v-data-table>

    <!-- Grand Total Row -->
    <div v-if="items && items.length > 0" class="d-flex justify-end mt-4">
      <div class="pa-3" style="min-width: 300px; max-width: 350px">
        <div class="d-flex justify-space-between align-center">
          <span style="font-weight: bold; font-size: 1.1em">Grand Total:</span>
          <span style="font-size: 1.1em">{{ grandTotal.toFixed(2) }}</span>
        </div>
      </div>
    </div>
  </v-card>
</template>

<script>


import { GrnService } from "@/services/grn-service.js";

export default {
  data() {
    return {
      grnDetails: {},  // Object to store GRN details
      items: [],       // Array to store items associated with the GRN
      loading: false,  // Loading indicator (if needed for data fetching)
      itemHeaders: [
        { text: "Item Name", value: "product_code" },
        { text: "Batch", value: "batch_id" },
        { text: "Description", value: "description" },
        { text: "Quantity", value: "quantity" },
        { text: "Unit Price", value: "unit_price" },
        { text: "Total Price", value: "total_price" },
        
      ],
    };
  },
  computed: {
    grandTotal() {
      return this.items.reduce(
        (sum, item) => sum + Number(item.total_price || 0),
        0,
      );
    },
  },
  created() {
    this.fetchGrnDetails();
  },
  methods: {
    async fetchGrnDetails() {
      try {
        // Fetch GRN details using the GRN uuid
        const response = await GrnService.getGrnDetails(this.$route.params.uuid);
        this.grnDetails = response;
        console.log("this.grnDetails", this.grnDetails)

        // Fetch items associated with the GRN after fetching the details
        this.fetchItems(this.grnDetails.id);
        console.log("grn_id : ",this.grnDetails.id)
      } catch (error) {
        console.error("Error fetching GRN details:", error);
      }
    },

    async fetchItems(id) {
      try {
        // Fetch items for the given GRN number
        const items = await GrnService.getItemsByGrnNumber(id);
        console.log("items : ",items)
        this.items = items; // Populate the items array with the retrieved data
      } catch (error) {
        console.error("Error fetching items for GRN:", error);
      }
    },

    printTable() {
      // GRN Details
      const grnDetails = `
        <div class="grn-header">
          <h1>GOODS RECEIVED NOTE</h1>
          <div class="grn-meta">
            <div><strong>GRN Number:</strong> ${
              this.grnDetails.grn_number || ""
            }</div>
            <div><strong>Supplier Name:</strong> ${
              this.grnDetails.supplier_name || ""
            }</div>
            <div><strong>PO Number:</strong> ${
              this.grnDetails.po_number || ""
            }</div>
            <div><strong>PO Date:</strong> ${
              this.grnDetails.po_date || ""
            }</div>
            <div><strong>Remarks:</strong> ${
              this.grnDetails.remarks || ""
            }</div>
          </div>
        </div>
        <hr>
      `;

      // Table HTML
      let tableHtml = `
        <table>
          <thead>
            <tr>
              <th>Item Name</th>
              <th>Batch</th>
              <th>Description</th>
              <th>Quantity Received</th>
              <th>Unit Price</th>
              <th>Total Price</th>
            </tr>
          </thead>
          <tbody>
            ${this.items
              .map(
                (item) => `
              <tr>
                <td>${item.product_code}</td>
                <td>${item.batch ? item.batch.batch_code : "N/A"}</td>
                <td>${item.description}</td>
                <td>${item.quantity_received}</td>
                <td>${item.unit_price}</td>
                <td>${item.total_price}</td>
              </tr>
            `,
              )
              .join("")}
          </tbody>
        </table>
      `;

      // Calculate grand total
      const grandTotal = this.items.reduce(
        (sum, item) => sum + Number(item.total_price || 0),
        0,
      );

      // Footer
      const grnFooter = `
        <div class="grn-footer">
          <hr>
          <div style="text-align:right; font-size:1.2em; margin-top:20px;">
            <strong>Grand Total:</strong> ${grandTotal.toFixed(2)}
          </div>
        </div>
      `;

      // Open print window
      const printWindow = window.open("", "_blank");
      printWindow.document.write(`
        <html>
          <head>
            <title>Print GRN</title>
            <style>
              body { font-family: Arial, sans-serif; padding: 40px; background: #f9f9f9; }
              .grn-container { background: #fff; border: 1px solid #ddd; border-radius: 8px; padding: 32px; max-width: 800px; margin: auto; }
              .grn-header { text-align: center; margin-bottom: 24px; }
              .grn-header h1 { margin-bottom: 8px; font-size: 2.2em; letter-spacing: 2px; }
              .grn-meta { text-align: left; margin-top: 16px; font-size: 1.1em; }
              hr { border: none; border-top: 1px solid #eee; margin: 24px 0; }
              table { width: 100%; border-collapse: collapse; margin-top: 16px; }
              th, td { border: 1px solid #ccc; padding: 10px; text-align: left; }
              th { background: #f5f5f5; }
              .grn-footer { margin-top: 32px; }
            </style>
          </head>
          <body>
            <div class="grn-container">
              ${grnDetails}
              ${tableHtml}
              ${grnFooter}
            </div>
          </body>
        </html>
      `);
      printWindow.document.close();
    },
  },
};
</script>
<style scoped>
.first-row {
  font-weight: bold;
}

.dark-row {
  background-color: #f4f4f4;
}

.light-row {
  background-color: #ffffff;
}

.custom-row:hover {
  background-color: #e8e8e8;
  cursor: pointer;
}
</style>
